import { Location } from '@app/shared/routes';

const BookingListLocation = new Location({ path: '/booking-list' });

export { BookingListLocation };
